module.exports = __webpack_public_path__ + "static/media/dark-logo.bd22c6a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/dark-logo.png
// module id = 407
// module chunks = 0